module.exports = __webpack_public_path__ + "img/picture.efda5ade.png";